import React from 'react';

import { InfoField } from '@occc-app/design-system';
import { AwardTransactionPercentDiscountFragment } from '@occc/graphql';

interface ITransactionPercentDiscountAwardPropsProps {
  award: AwardTransactionPercentDiscountFragment;
}

export const TransactionPercentDiscountAward: React.FC<
  ITransactionPercentDiscountAwardPropsProps
> = ({ award }) => {
  return <InfoField label='Percent Discount' value={award.percentDiscount} />;
};
